import { Model } from 'src/containers/ProjectDiagram/types/model';
import { setColorIdForIri } from 'src/containers/ProjectDiagram/utils/colorIds';
import { isModelConceptClass } from 'src/containers/ProjectDiagram/utils/data';
import { setDescriptionForIri } from 'src/containers/ProjectDiagram/utils/descriptions';
import { setLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import {
  createModelConceptClass,
  getModelConceptClassKey,
} from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';
import { addProjectModelIdsToIri } from 'src/containers/ProjectDiagram/utils/projectModelIds';
import { restoreDeletedClass } from 'src/containers/ProjectDiagram/utils/restoreDeletedData';

export const addModelConceptClass =
  ({
    iri,
    label,
    description,
    colorId,
    projectModelIds,
  }: {
    iri: string;
    label: string;
    description?: string;
    colorId?: string;
    projectModelIds: string[];
  }) =>
  (model: Model) => {
    const key = getModelConceptClassKey(iri);
    const existingClass = model.nodeDataArray.find(
      (nodeData) => isModelConceptClass(nodeData) && nodeData.key === key
    );
    if (existingClass) {
      return;
    }

    const data = createModelConceptClass({ value: iri });

    setColorIdForIri(iri, colorId)(model);
    setLabelForIri(iri, label)(model);
    if (description) {
      setDescriptionForIri(iri, description)(model);
    }

    model.addNodeData(data);

    restoreDeletedClass(data)(model);

    addProjectModelIdsToIri(iri, projectModelIds)(model);
  };
